import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&utm_source=FB&country=US&area=female&exp=web_female_risk_free_offer~1
			funnel: {
				id: 'ob-female-risk-free-offer',
				locale: ['en'],
			},
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_female_risk_free_offer'
					),
			},
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_female_risk_free_offer'),
			},
		},
	},
]

export default config
